import CityPageTemplate from "../city-template/CityPageTemplate";
import { kentwoodConfig } from "./data";

export default function KentwoodPage() {
  return <CityPageTemplate config={kentwoodConfig} />;
}